import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationStageFinanceAttributions(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].GET_REGULATION_STAGE_FINANCE_ATTRIBUTIONS,
		options
	)
}

function _getRegulationStageFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].GET_REGULATION_STAGE_FINANCE_ATTRIBUTION,
		options
	)
}

function _createRegulationStageFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].CREATE_REGULATION_STAGE_FINANCE_ATTRIBUTION,
		options
	)
}

function _putRegulationStageFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].PUT_REGULATION_STAGE_FINANCE_ATTRIBUTION,
		options
	)
}

function _patchRegulationStageFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].PATCH_REGULATION_STAGE_FINANCE_ATTRIBUTION,
		options
	)
}

function _deleteRegulationStageFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].DELETE_REGULATION_STAGE_FINANCE_ATTRIBUTION,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].GET_REGULATION_STAGE_FINANCE_ATTRIBUTIONS]: _getRegulationStageFinanceAttributions,

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].GET_REGULATION_STAGE_FINANCE_ATTRIBUTION]: _getRegulationStageFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].CREATE_REGULATION_STAGE_FINANCE_ATTRIBUTION]: _createRegulationStageFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].PUT_REGULATION_STAGE_FINANCE_ATTRIBUTION]: _putRegulationStageFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].PATCH_REGULATION_STAGE_FINANCE_ATTRIBUTION]: _patchRegulationStageFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].DELETE_REGULATION_STAGE_FINANCE_ATTRIBUTION]: _deleteRegulationStageFinanceAttribution,
}
